module.exports = __webpack_public_path__ + "img/62.9.TU.f7b596e2.png";